import { RootState, AppDispatch } from '@internal/redux'
import { IReduxMapDispatch, IReduxMapState } from './redux.types'
import { fetchCategoryDetailThunk, fetchCategoryUpdateThunk } from './redux.thunks'
import CategoryDetailSlice from './redux.slice'

export const mapStateToProps = (state: RootState): IReduxMapState => ({
  status: state.CategoryDetailSlice.status,
  slice: state.CategoryDetailSlice
})

export const mapDispatchToProps = (dispatch: AppDispatch): IReduxMapDispatch => ({
  fetchData(param) {
    return dispatch(fetchCategoryDetailThunk({ mediaId: param?.mediaId, isClear: true }))
  },
  onChangeStatus: (status) => {
    dispatch(CategoryDetailSlice.actions.onChangeStatus(status))
  },
  onUpdateCategory: async (params) => {
    dispatch(fetchCategoryUpdateThunk(params))
  }
})
